import { openDB } from 'idb';

const DB_NAME = "scoresDB";
const STORE_NAME = "scores";

export async function initDB() {
    return openDB(DB_NAME, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: "id" }); // id unique pour chaque score
            }
        }
    });
}

export async function saveScoreOffline(score) {
    const db = await initDB();
    await db.put(STORE_NAME, { ...score, id: `${score.idUser}-${score.idQuestion}` }); 
}

export async function getPendingScores() {
    const db = await initDB();
    return db.getAll(STORE_NAME);
}

export async function removeScore(id) {
    const db = await initDB();
    await db.delete(STORE_NAME, id);
}